<template>
    <img :src="src" @error="imgErrorhandle"/>
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      err_url: require('@/assets/icon/imgErr.svg')
    }
  },
  methods: {
    // 图片加载失败处理
    imgErrorhandle (e) {
      // console.log(e);
      // let img = e.srcElement;
      // img.src = '';
      
      // img.onerror = null; //防止
      e.target.style.opacity = 0;
      // e.target.style.ransition = ' opacity 0.5s ease-in-out';
      // e.target.style.filter = 'grayscale(100%)';
    }
  }, 
}
</script>
